import { useLazySearchNominatimReverseQuery } from 'redux/services/stopsService';
import { useLazySearchNominatimQuery } from 'redux/services/stopsService';
import { useLanguage } from 'context/languageContext';
import { useDispatch } from 'react-redux';
import {
  TYPES_MARKERS,
  zoomAcercarseAMarcador
} from 'utils/constants';
import {
  flyTo,
  updateMarkerSelected,
  updateMarkerSelectedType,
} from 'redux/slices/mapSlice';
import { useSelector } from 'react-redux';
import { ReactComponent as Ic_Location_Dark } from 'resources/icons/Ic_Location_Dark.svg';
import { updateSelectedNominatimPoi } from 'redux/slices/nominatimSlice';
import {
  plannerSegmentsInformation,
  plannerSegmentsSlice,
} from 'redux/slices/plannerSegmentsSlice';

export const useNominatim = ()=> {
    const currentLanguage = useLanguage();
    const dispatch = useDispatch();
    const [ SearchNominatimReverse ] = useLazySearchNominatimReverseQuery();
    const plannerSegments = useSelector(plannerSegmentsInformation);
    const [ SearchNominatim ] = useLazySearchNominatimQuery();

    const getNominatimReverse = ({lat, lng, planner}: {lat:number, lng:number, planner?:boolean})=> {

        SearchNominatimReverse({ lat, lng, language: currentLanguage })
        .then((response) => {
            const isResponse = response?.data?.[0];
            if (isResponse) {
                if(planner) {
                    const res = {};
                    res['position'] = { lat: Number(isResponse?.latitide), lng: Number(isResponse?.longitude) };//latitide es un error de la api
                    res['name'] = isResponse?.streetName;
                    res['street'] = isResponse?.streetName;
                    res['desc'] = isResponse.category;
                    res['id'] = Number(String(isResponse?.longitude + isResponse?.latitide).replaceAll('.',''));
                    if (!plannerSegments[0]) {
                        dispatch(plannerSegmentsSlice.actions.set({ index: 0, overwrite: true, stop: res }));
                    } else if (!plannerSegments[1]) {
                        dispatch(plannerSegmentsSlice.actions.set({ index: 1, overwrite: true, stop: res }));
                    }
                } else {
                    const item = {
                        id: Number(String(isResponse?.longitude + isResponse?.latitide).replaceAll('.','')),
                        name: isResponse?.streetName,
                        street: isResponse?.streetName,
                        code: isResponse.category,
                        transportMode: isResponse.type,
                        type: TYPES_MARKERS.NOMINATIM,
                        position: {
                        lng: Number(isResponse?.longitude),
                        lat: Number(isResponse?.latitide),
                        } ,
                        icon:Ic_Location_Dark
                    };
                    dispatch(updateSelectedNominatimPoi(item));
                    dispatch(updateMarkerSelected(item.id));
                    dispatch(updateMarkerSelectedType(TYPES_MARKERS.NOMINATIM));
                    setTimeout(
                        () =>
                        dispatch(
                            flyTo({
                            coords: { lat: item?.position?.lat, lng: item?.position?.lng },
                            zoom: zoomAcercarseAMarcador,
                            }),
                        ),
                        300,
                    );
                    dispatch(updateSelectedNominatimPoi(item));
                }



            }
        });
    };

    const SearchNominatimByPage = async ({searchText, page, perPage}:{searchText:string, page:number, perPage:number})=> {
        try {
            const responseNominatim = await SearchNominatim({ txt: searchText, language: currentLanguage, page, perPage });
            return responseNominatim?.data?.length ? responseNominatim : [];
        } catch (error: any) {
          if (error.name === 'AbortError') {
          } else {
            console.error('Error en la búsqueda:', error);
          }
        }
      };

    return {
        getNominatimReverse,
        SearchNominatimByPage
    };

};
